import Chart from 'chart.js/auto';

export default class ChartDoughnut {
  constructor(element) {
    if (!(element instanceof HTMLCanvasElement)) {
      throw new Error('Element must be a <canvas> element.');
    }
    this.canvas = element;
    this.context = this.canvas.getContext('2d');
    this.value = parseInt(this.canvas.dataset.value, 10) || 0;
    this.total = parseInt(this.canvas.dataset.total, 10) || 1;
    this.type = this.canvas.dataset.type || 'ratio'; // Default to 'ratio' if not specified
    this.animationStarted = false;
    this.initObserver();
  }

  initObserver() {
    // Observer to listen for class addition
    const observer = new MutationObserver(() => {
      if (this.canvas.classList.contains('is-inview') && !this.animationStarted) {
        this.animationStarted = true;
        this.initChart();
      }
    });

    observer.observe(this.canvas, {
      attributes: true, // Watch for attribute changes
      attributeFilter: ['class'], // Only watch the 'class' attribute
    });
  }

  initChart() {
    const remaining = this.total - this.value;
    const percentage = Math.round((this.value / this.total) * 100); // Remove decimal by rounding

    // Initialize the Chart.js doughnut chart
    new Chart(this.context, {
      type: 'doughnut',
      data: {
        labels: ['Value', 'Remaining'],
        datasets: [
          {
            data: [this.value, remaining],
            backgroundColor: ['#FF6384', '#EAEAEA'], // Adjust colors as needed
          },
        ],
      },
      options: {
        responsive: true,
        cutout: "75%",
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false, // Disable tooltips
          },

        },
      },
      plugins: [
        {
          id: 'doughnutLabel',
          beforeDraw: (chart) => {
            const { width } = chart;
            const { height } = chart;
            const ctx = chart.ctx;

            // Calculate the center of the doughnut chart
            const centerX = width / 2;
            const centerY = height / 2;

            let labelText = '';
            // Check the data-type attribute to determine which label to show
            if (this.type === 'percentage') {
              labelText = `${percentage}%`; // Show percentage
            } else if (this.type === 'ratio') {
              labelText = `${this.value}/${this.total}`; // Show ratio
            }

            // Draw the label
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '35px Replica-Bold';
            ctx.fillStyle = '#333';
            ctx.fillText(labelText, centerX, centerY);
            ctx.restore();
          },
        },
      ],
    });
  }
}